module.exports = __webpack_public_path__ + "img/courseReview.7c01de26.svg";